import TranslationsTable from "./translations-table";

export default TranslationsTable;
